import { SLIDER_INTERVAL } from './constants'

export const ProgressCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    className="-rotate-90"
  >
    <circle cx="16" cy="16" r="12" stroke="white" strokeWidth="3" fill="none" />
    <circle
      cx="16"
      cy="16"
      r="12"
      stroke="#BEC4D5"
      strokeWidth="3"
      fill="none"
      strokeDasharray="75.4"
      strokeDashoffset="75.4"
      style={{
        animation: `progress ${SLIDER_INTERVAL / 1000}s linear infinite`,
      }}
    />
    <style>
      {`
        @keyframes progress {
          from {
            stroke-dashoffset: 75.4;
          }
          to {
            stroke-dashoffset: 0;
          }
        }
      `}
    </style>
  </svg>
)
